import { forwardRef, HTMLAttributes, Ref } from 'react'
import { SPACING } from 'shared/theme'
import styled, { css, IStyledComponent } from 'styled-components'

import { AddPrefixToObject } from '../../helpers/typeHelper'
import { breakpoints } from '../../theme/breakpoints'
import { Colors } from '../../theme/colors'

const StyledDivider = styled.div<AddPrefixToObject<DividerProps, '$'>>`
  ${(p) =>
    p.$vertical
      ? `border-left: ${p.$borderWidth ?? '1px'} solid ${Colors.lightGray3};`
      : `border-top: ${p.$borderWidth ?? '1px'} solid ${Colors.lightGray3};`}

  ${(p) => p.$width && `width: ${p.$width};`}
  ${(p) => p.$height && `height: ${p.$height};`}
  ${(p) => p.$color && `border-color: ${p.$color};`}
  ${(p) => p.$margin && `margin: ${p.$margin};`}

  ${(p) =>
    p.$mt &&
    css`
      margin-top: ${SPACING * p.$mt}px;
    `};

  ${(p) =>
    p.$mb &&
    css`
      margin-bottom: ${SPACING * p.$mb}px;
    `};

  ${(p) =>
    p.$ml &&
    css`
      margin-left: ${SPACING * p.$ml}px;
    `};

  ${(p) =>
    p.$mr &&
    css`
      margin-right: ${SPACING * p.$mr}px;
    `};

  @media ${breakpoints.xs} {
    ${(p) =>
      p.$xsmt &&
      css`
        margin-top: ${SPACING * p.$xsmt}px;
      `};

    ${(p) =>
      p.$xsmb &&
      css`
        margin-bottom: ${SPACING * p.$xsmb}px;
      `};
  }
`

export interface DividerProps {
  mt?: number
  mb?: number
  ml?: number
  mr?: number
  xsmt?: number
  xsmb?: number
  width?: string
  height?: string
  color?: string
  borderWidth?: string
  margin?: string
  vertical?: boolean
}

export const Divider = forwardRef(
  (
    { mt, mb, ml, mr, xsmt, xsmb, width, height, color, borderWidth, margin, vertical, ...rest },
    ref: Ref<any>
  ) => {
    return (
      <StyledDivider
        $mt={mt}
        $mb={mb}
        $ml={ml}
        $mr={mr}
        $xsmt={xsmt}
        $xsmb={xsmb}
        $width={width}
        $height={height}
        $color={color}
        $borderWidth={borderWidth}
        $margin={margin}
        $vertical={vertical}
        ref={ref}
        {...rest}
      />
    )
  }
) as IStyledComponent<'web', DividerProps & HTMLAttributes<HTMLDivElement> & { ref?: Ref<any> }>

export const StyledVerticalDivider = styled.div<AddPrefixToObject<VerticalDividerProps, '$'>>`
  height: 24px;
  width: 1px;
  display: inline-block;
  border-right: 1px solid ${Colors.lightGray3};
  ${(p) => p.$height && `height: ${p.$height};`}
  ${(p) => p.$margin && `margin: ${p.$margin};`}
`

interface VerticalDividerProps {
  height?: string
  margin?: string
}

export const VerticalDivider = forwardRef(({ height, margin, ...rest }, ref: Ref<any>) => {
  return <StyledVerticalDivider $height={height} $margin={margin} ref={ref} {...rest} />
}) as IStyledComponent<'web', VerticalDividerProps & HTMLAttributes<HTMLDivElement> & { ref?: Ref<any> }>
